var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticStyle: {
            position: "fixed",
            margin: "auto",
            width: "290px",
            "border-radius": "2px",
            "background-color": "#ffffff",
            "box-shadow": "0 0 5px rgba(0, 0, 0, 0.2)",
          },
          style: {
            height: _vm.CurrentHeight,
            top: _vm.currentTop,
            left: _vm.currentLeft,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              if ($event.target !== $event.currentTarget) return null
            },
          },
        },
        [
          _c("div", { staticStyle: { height: "100%" } }, [
            _c(
              "p",
              {
                staticStyle: {
                  "border-bottom": "1px solid #eaeaea",
                  "text-align": "left",
                  height: "45px",
                  "line-height": "45px",
                  "font-weight": "800",
                  "margin-left": "10px",
                },
              },
              [_vm._v("个人信息")]
            ),
            _vm.informationData.account.length == 32
              ? _c("div", [
                  _vm.informationData.nickInTeam
                    ? _c(
                        "p",
                        {
                          staticStyle: {
                            height: "30px",
                            "line-height": "30px",
                            "padding-left": "15px",
                          },
                        },
                        [
                          _c("span", [_vm._v("群昵称：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.informationData.nickInTeam)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        height: "30px",
                        "line-height": "30px",
                        "padding-left": "15px",
                      },
                    },
                    [
                      _c("span", [_vm._v("昵称：")]),
                      _c("span", [_vm._v(_vm._s(_vm.informationData.nick))]),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        height: "30px",
                        "line-height": "30px",
                        "padding-left": "15px",
                      },
                    },
                    [
                      _c("span", [_vm._v("手机号：")]),
                      _c("span", [_vm._v(_vm._s(_vm.informationData.tel))]),
                    ]
                  ),
                ])
              : _c("div", [
                  _vm.informationData.nickInTeam
                    ? _c(
                        "p",
                        {
                          staticStyle: {
                            height: "30px",
                            "line-height": "30px",
                            "padding-left": "15px",
                          },
                        },
                        [
                          _c("span", [_vm._v("群昵称：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.informationData.nickInTeam)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        height: "30px",
                        "line-height": "30px",
                        "padding-left": "15px",
                      },
                    },
                    [
                      _c("span", [_vm._v("姓名：")]),
                      _c("span", [_vm._v(_vm._s(_vm.informationData.nick))]),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        height: "30px",
                        "line-height": "30px",
                        "padding-left": "15px",
                      },
                    },
                    [
                      _c("span", [_vm._v("岗位：")]),
                      _c("span", [_vm._v(_vm._s(_vm.custom.role))]),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        height: "30px",
                        "line-height": "30px",
                        "padding-left": "15px",
                      },
                    },
                    [
                      _c("span", [_vm._v("网点名称：")]),
                      _c("span", [_vm._v(_vm._s(_vm.custom.stationName))]),
                    ]
                  ),
                ]),
            _vm.informationData.scene == "team" && !_vm.isRobot
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "margin-top": "10px",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        staticStyle: {
                          width: "150px",
                          "border-radius": "25px",
                          background: "#653EB3",
                          color: "#ffffff",
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.itemClickEvent(_vm.informationData)
                          },
                        },
                      },
                      [_vm._v("发消息")]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }